<div class="tabs-container">
    <tabs (tabClicked)="onTabClicked($event)">
        <tab title="New">
            <ag-grid-angular class="data-grid " [gridOptions]="pendingGridOptions" [rowData]="dataPending"  [attr.aria-label]="widgetTitle + ' - New'"></ag-grid-angular>
        </tab>
        <tab title="In Progress">
            <ag-grid-angular class="data-grid " [gridOptions]="progressGridOptions" [rowData]="dataProgress"  [attr.aria-label]="widgetTitle + ' - In Progress'"></ag-grid-angular>
        </tab>
        <tab title="Escalation Review">
            <ag-grid-angular class="data-grid " [gridOptions]="escalatedGridOptions" [rowData]="dataEscalated"  [attr.aria-label]="widgetTitle + ' - Escalation Review'"></ag-grid-angular>
        </tab>
        <tab title="Contested">
            <ag-grid-angular class="data-grid " [gridOptions]="contestedGridOptions" [rowData]="dataContested"  [attr.aria-label]="widgetTitle + ' - Contested'"></ag-grid-angular>
        </tab>
        <tab title="Closed">
            <ag-grid-angular class="data-grid " [gridOptions]="closedGridOptions" [rowData]="dataClosed"  [attr.aria-label]="widgetTitle + ' - Closed'"></ag-grid-angular>
        </tab>
    </tabs>
</div>